import { Link, useLocation } from "react-router-dom";
import { Building2, Radio } from "lucide-react";

const tabs = [
  { href: "/businesses", label: "Businesses", icon: Building2, exact: true },
  { href: "/businesses/connected-services", label: "Approvals", icon: Radio, exact: false },
] as const;

export function BusinessMenuNav({ pendingCount = 0 }: { pendingCount?: number }) {
  const { pathname } = useLocation();

  return (
    <nav className="flex flex-wrap gap-2" aria-label="Businesses menu">
      {tabs.map(({ href, label, icon: Icon, exact }) => {
        const active = exact
          ? pathname === href
          : pathname.startsWith(href);
        return (
          <Link
            key={href}
            to={href}
            className={
              active
                ? "inline-flex items-center gap-2 rounded-full bg-foreground px-4 py-2 text-sm font-semibold text-surface transition"
                : "inline-flex items-center gap-2 rounded-full bg-canvas px-4 py-2 text-sm font-semibold text-muted transition hover:bg-canvas-hover hover:text-foreground"
            }
          >
            <Icon className="h-4 w-4" />
            {label}
            {href.includes("connected-services") && pendingCount > 0 ? (
              <span
                className={
                  active
                    ? "rounded-full bg-accent px-1.5 py-0.5 text-[10px] font-extrabold text-accent-foreground"
                    : "rounded-full bg-accent-subtle px-1.5 py-0.5 text-[10px] font-extrabold text-accent-foreground"
                }
              >
                {pendingCount}
              </span>
            ) : null}
          </Link>
        );
      })}
    </nav>
  );
}
